const isBrowser = () => typeof document !== "undefined";
const isServer = () => !isBrowser();

export { isBrowser, isServer };
